export enum Preset {
  Today = 'TODAY',
  PastThreeDays = 'PAST_3_DAYS',
  PastSevenDays = 'PAST_7_DAYS',
  PastThirtyDays = 'PAST_30_DAYS',
  Custom = 'CUSTOM_RANGE',
  JourneyStart = 'JOURNEY_START',
  SinceLastPublished = 'SINCE_LAST_PUBLISHED',
}
